import { initAccordion } from './accordions/initAccordion';
import { initFaqAccordion } from './accordions/initFaqAccordion';

export const initAccordions = () => {
    initAccordion();
    initFaqAccordion();
};
